import { render } from "./ChiTietBaiViet.vue?vue&type=template&id=ecdf33e4&scoped=true"
import script from "./ChiTietBaiViet.vue?vue&type=script&lang=js"
export * from "./ChiTietBaiViet.vue?vue&type=script&lang=js"

import "./ChiTietBaiViet.vue?vue&type=style&index=0&id=ecdf33e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecdf33e4"]])

export default __exports__